import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MapUtilService {
  constructor() {}
  simplifyCoordinatesAdvanced(coordinates: number[][], tolerance: number = 0.0001): number[][] {
    if (coordinates.length <= 2) return coordinates;

    function getPerpendicularDistance(point: number[], lineStart: number[], lineEnd: number[]): number {
      const [x, y] = point;
      const [x1, y1] = lineStart;
      const [x2, y2] = lineEnd;

      if (x1 === x2 && y1 === y2) {
        return Math.sqrt((x - x1) ** 2 + (y - y1) ** 2);
      }

      const A = x - x1;
      const B = y - y1;
      const C = x2 - x1;
      const D = y2 - y1;

      const dot = A * C + B * D;
      const lenSq = C * C + D * D;
      const param = lenSq !== 0 ? dot / lenSq : -1;

      let xx, yy;

      if (param < 0) {
        xx = x1;
        yy = y1;
      } else if (param > 1) {
        xx = x2;
        yy = y2;
      } else {
        xx = x1 + param * C;
        yy = y1 + param * D;
      }

      const dx = x - xx;
      const dy = y - yy;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function douglasPeucker(points: number[][], tolerance: number): number[][] {
      if (points.length <= 2) return points;

      let maxDistance = 0;
      let maxIndex = 0;

      for (let i = 1; i < points.length - 1; i++) {
        const distance = getPerpendicularDistance(
          points[i],
          points[0],
          points[points.length - 1]
        );
        if (distance > maxDistance) {
          maxDistance = distance;
          maxIndex = i;
        }
      }

      if (maxDistance > tolerance) {
        const left = douglasPeucker(points.slice(0, maxIndex + 1), tolerance);
        const right = douglasPeucker(points.slice(maxIndex), tolerance);
        return left.slice(0, -1).concat(right);
      } else {
        return [points[0], points[points.length - 1]];
      }
    }

    return douglasPeucker(coordinates, tolerance);
  }
}
